export const NAME_OF_MODULE_SLICE = "manageModuleSlice";
export const CREATE_MODULE_GROUP = "module/create_moduel_group";
export const NAME_OF_MODULE_GROUP_SLICE = "manageModuleGroupSlice";
export const USERS_SECURITY_API_URL         = 'users-security'
export const GET_ALL_USERS_SECURITY_API_URL         = 'get-all-users-security'
export const USERS_SECURITY       = 'manageUsersSecuritySlice'


export const MANAGE_PERMISSIONS_API_URL         = 'manage-permissions'
export const GET_ALL_MANAGE_PERMISSIONS_API_URL         = 'get-all-manage-permissions'
export const MANAGE_PERMISSIONS       = 'manageManagePermissionsSlice'


export const MANAGE_ROLE_API_URL         = 'manage-role'
export const GET_ALL_MANAGE_ROLE_API_URL         = 'get-all-manage-role'
export const MANAGE_ROLE       = 'manageManageRoleSlice'


export const MANAGE_ROLE_PERMISSION_API_URL         = 'manage-role-permission'
export const GET_ALL_MANAGE_ROLE_PERMISSION_API_URL         = 'get-all-manage-role-permission'
export const MANAGE_ROLE_PERMISSION       = 'manageManageRolePermissionSlice'
export const GET_MODULE_WITH_PERMISSION = "get-module-with-permission";
export const GET_EXCLUDED_ROLE = 'get-excluded-routes';


export const MANAGE_USER_API_URL         = 'manage-user'
export const GET_ALL_MANAGE_USER_API_URL         = 'get-all-manage-user'
export const MANAGE_USER       = 'manageManageUserSlice'


export const LOOKUPS_API_URL         = 'lookups'
export const GET_ALL_LOOKUPS_API_URL         = 'get-all-lookups'
export const LOOKUPS       = 'manageLookupsSlice'


export const COURSE_API_URL         = 'course'
export const GET_ALL_COURSE_API_URL         = 'get-all-course'
export const COURSE       = 'manageCourseSlice'


export const SUBJECT_API_URL         = 'subject'
export const GET_ALL_SUBJECT_API_URL         = 'get-all-subject'
export const SUBJECT       = 'manageSubjectSlice'


export const UPLOAD_QUIZ_API_URL         = 'upload-quiz'
export const GET_ALL_UPLOAD_QUIZ_API_URL         = 'get-all-upload-quiz'
export const UPLOAD_QUIZ       = 'manageUploadQuizSlice'

export const MANAGE_ENROLLEMENT_API_URL         = 'manage-enrollement'
export const GET_ALL_MANAGE_ENROLLEMENT_API_URL         = 'get-all-manage-enrollement'
export const GET_MANAGE_ENROLLEMENT_COURSES_API_URL         = 'manage-enrollement-courses'
export const VERIFY_MANAGE_ENROLLEMENT_PAYMENT_API_URL         = 'manage-enrollement'
export const MANAGE_ENROLLEMENT       = 'manageManageEnrollementSlice'

export const ATTEMPT_QUIZ_API_URL         = 'attempt-quiz'
export const GET_ALL_ATTEMPT_QUIZ_API_URL         = 'get-all-attempt-quiz'
export const ATTEMPT_QUIZ       = 'manageAttemptQuizSlice'

export const STUDENT_QUIZZES_API_URL = 'student-quizzes'
export const STUDENT_QUIZ_START_API_URL = 'student-quiz/start'
export const STUDENT_QUIZ_SUBMIT_API_URL = 'student-quiz/submit'
export const STUDENT_QUIZ_ATTEMPTS_API_URL = 'student-quiz/attempts'
export const STUDENT_QUIZ_ATTEMPT_RESULT_API_URL = 'student-quiz/attempt/result'

